export default "__VITE_ASSET__BKjfo5zd__"